'use strict';

var contactUsForm = {
	_animationClass: '',
	_dom: {
		wrapper: null,
		form: null
	},
	_initSubmit: function () {

		$('#contact-us .modal-body').on( 'submit' , 'form', function( event ) {

			event.preventDefault();
			var data = $(this).serialize();
			var language = $(this).attr('data-language');

			$.ajax({
				method: 'Post',
				url: '/stage-ajax/contactUsFormSubmit/?stage-language=' + language,
				data: data,
				context: document.body
			}).done( function(data) {
				$('#contact-us .modal-body .contact-us-form').replaceWith(data.markup);
			});

		});

	},
	init: function () {

		this._dom.wrapper = $('.contact-us-form');

		if (this._dom.wrapper.length > 0) {
			this._initSubmit();
		}
	}
};

